import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getMessageFromError } from "../../../shared/welda/services/utilsService";
import errorHandling from "../errorHandling";
import trackingService from "./trackingService";

const initialState = {
  getMailDetailsState: {
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: null,
    data: null,
  },
};

export const getMailDetails = createAsyncThunk(
  "tracking/getMailDetails",
  async (params, thunkAPI) => {
    try {
      const awaitgetMailDetails = await trackingService.getMailDetails(params);
      return awaitgetMailDetails;
    } catch (error) {
      const message = getMessageFromError(error);
      error.toString();
      errorHandling(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const trackingSlice = createSlice({
  name: "tracking",
  initialState,
  reducers: {
    reset: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMailDetails.pending, (state) => {
        state.getMailDetailsState.isLoading = true;
        state.getMailDetailsState.message = null;
      })
      .addCase(getMailDetails.fulfilled, (state, action) => {
        state.getMailDetailsState.isLoading = false;
        state.getMailDetailsState.isSuccess = true;
        state.getMailDetailsState.data = action.payload;
        state.getMailDetailsState.message = null;
      })
      .addCase(getMailDetails.rejected, (state, action) => {
        state.getMailDetailsState.isLoading = false;
        state.getMailDetailsState.isError = true;
        state.getMailDetailsState.message = action.payload;
      });
  },
});

export const { reset } = trackingSlice.actions;
export default trackingSlice.reducer;
